// extracted by mini-css-extract-plugin
module.exports = {"notification__container":"Notification-container_notification__container__1CS22"};